var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParagraphBoxed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24919 1.13877C2.42821 1.13877 0.952006 2.61497 0.952006 4.43596V22.0691C0.952006 23.8901 2.4282 25.3663 4.24919 25.3663H22.0693C23.8903 25.3663 25.3665 23.8901 25.3665 22.0691V4.43596C25.3665 2.61497 23.8903 1.13877 22.0693 1.13877H4.24919Z",
    fill: "#FAFAFA",
    stroke: "#D0D8DC",
    strokeWidth: 0.732708
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99902 6.99902H19V19H6.99902V6.99902Z",
    stroke: "#7E898F",
    strokeWidth: 1.50021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7998 9.39941H16.6002",
    stroke: "#7E898F",
    strokeWidth: 1.50021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39905 14.1995H16.5996",
    stroke: "#7E898F",
    strokeWidth: 1.50021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39905 11.7996H16.5996",
    stroke: "#7E898F",
    strokeWidth: 1.50021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39957 16.5996H13.3999",
    stroke: "#7E898F",
    strokeWidth: 1.50021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraphBoxed);
export default __webpack_public_path__ + "static/media/ParagraphBoxed.edf75d540aa741553440081317879816.svg";
export { ForwardRef as ReactComponent };